module.exports = __webpack_public_path__ + "static/media/5DPO24.b81b62ea.jpg";